// extracted by mini-css-extract-plugin
export default {"dialog":"Wx5a","hidden":"a93T","submitButton":"pEJZ"};